import { AfterViewInit, ChangeDetectorRef, Directive, HostBinding, Input, OnDestroy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { FormFieldComponent } from '@vendasta/galaxy/form-field';
import { Subject, combineLatest, of } from 'rxjs';
import { switchMap, takeUntil, tap } from 'rxjs/operators';
import { FieldValidation } from '../../field-validation';
import { FieldWarningService } from './field-warning.service';

@Directive({
  selector: '[crmFieldWarning]',
  standalone: true,
})
export class CrmFieldWarningDirective implements AfterViewInit, OnDestroy {
  private destroyed$$ = new Subject<void>();
  private hasWarnings = false;

  @Input({ alias: 'crmFieldWarning', required: true }) fieldValidation: FieldValidation;
  @Input({ required: true }) warningControl: UntypedFormControl;

  @HostBinding('class.crm-field-warning')
  get hasWarningsClass() {
    return this.hasWarnings;
  }

  constructor(
    private formFieldComponent: FormFieldComponent,
    private warningService: FieldWarningService,
    private readonly cd: ChangeDetectorRef,
  ) {}

  ngAfterViewInit(): void {
    combineLatest([this.warningControl.valueChanges, this.warningControl.statusChanges])
      .pipe(
        takeUntil(this.destroyed$$),
        switchMap(([, statusChanges]) => {
          if (statusChanges === 'INVALID') {
            return of(null);
          }
          return this.warningService.validateWarning(
            this.warningControl,
            this.fieldValidation.getAsyncWarningValidators(),
            this.fieldValidation.getWarningValidators(),
          );
        }),
        tap((warnings) => {
          if (warnings !== null && Object.keys(warnings).length > 0) {
            this.hasWarnings = true;
            this.formFieldComponent.prefixIcon = 'warning';
          } else {
            this.hasWarnings = false;
            this.formFieldComponent.prefixIcon = '';
          }
          this.cd.markForCheck();
        }),
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.destroyed$$.next(null);
    this.destroyed$$.unsubscribe();
  }
}
